import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface ItemTitleProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const ItemTitle = ({ className, ref, ...props }: ItemTitleProps) => (
  <div
    ref={ref}
    data-slot="item-title"
    className={cn("min-w-0 truncate text-sm font-medium leading-snug", className)}
    {...props}
  />
);
